import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetAllUsersList } from "../../../utilities/api/user/user-service";

export type UserListSliceType = {
    fullName: string
    role: string
    phone: string
    email: string
    aadharNumber: string
    id: string
}

const initialState = {
    AllUserList: [] as UserListSliceType[],
}

export const AllUsersList = createAsyncThunk("UserList/AllUserList", () => GetAllUsersList())

const UsersListSlice = createSlice({
    name: "UserList",
    initialState,
    reducers: {
        resetUserListSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder

            .addCase(AllUsersList.fulfilled, (state, action: PayloadAction<any>) => {
                if (!action.payload?.data?.rows) return;
                state.AllUserList = action.payload.data.rows.map((item: any) => {
                    return ({
                        fullName: item.firstName + " " + item.lastName,
                        role: item.userRole?.role?.displayName,
                        phone: item.phone,
                        email: item.email ? item.email : "-",
                        aadharNumber: item.aadharNumber ? item.aadharNumber : "-",
                        id: item.id,
                        isActive: item.isActive ? "Active" : "Inactive"
                    }
                    )
                })
            })

    }

})

export default UsersListSlice.reducer
export const { resetUserListSlice } = UsersListSlice.actions